import angular from "angular";

angular.module('ticketco/common/arena', [
  'ticketco/common',
  'ngMessages',
  'ngDialog',
]).run(function ($http) {
  $http.defaults.headers.common = {'Accept': 'application/json'};
});
